import PropTypes from 'prop-types';
import React from 'react';

const Icon = props =>
  <i className={`fa fa-${props.name}`} />;

Icon.propTypes = {
  name: PropTypes.string,
};

module.exports = Icon;



// WEBPACK FOOTER //
// ./app/components/common/icon/Icon.jsx